(function($) {
    $(function() {

        // CUSTOM NUMBER INPUT CHANGES
        $('.editor-slider').slick({
            infinite: false,
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: true,
            nextArrow: '.editor-slider-container .arrow--right',
            prevArrow: '.editor-slider-container .arrow--left'
        });

        $('.editor-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if(nextSlide == 0) {
                $('.editor-slider-container .arrow--right').addClass('is-hidden');
            }
        });

    });
})(jQuery);
